import styled from 'styled-components';
import { COLORS, DEVICES, FONT_FAMILY } from '@Commons';

export const SelectRecipientContents = styled.div`
  width: 450px;
  margin-top: 48px;
  text-align: center;

  .addNewButton {
    margin-top: 24px;
  }

  @media ${DEVICES.mobileXL} {
    width: 90% !important;
    margin: 48px 20px;
  }
`;

export const InfoContainer = styled.div`
  .heading {
    font-family: ${FONT_FAMILY.hellix.bold};
    font-size: 16px;
    line-height: 26px;
    font-weight: 700;
    color: ${COLORS.black};
    text-align: left;
  }

  .swiftCodeContainer {
    text-align: right;
    font-size: 12px;
    line-height: 16px;
    font-weight: 400;
    .here {
      color: ${COLORS.darkBlue};
      cursor: pointer;
    }
  }

  @media ${DEVICES.mobileXL} {
    .swiftCodeContainer {
      margin-top: 15px;
    }
  }
`;

export const HeadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-top: -35px;
  color: ${COLORS.black};
  font-family: ${FONT_FAMILY.hellix.bold};
  font-size: 28px;
  line-height: 38px;

  @media ${DEVICES.mobileXL} {
    margin: 0 10px 0;
  }
  @media ${DEVICES.mobileL} {
    margin: 0 10px 0 30px;
  }
`;

export const EmptyContainer = styled.div`
  height: 500px;
`;
